import { Component, HostListener, OnInit, inject } from '@angular/core';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatBadgeModule } from '@angular/material/badge';

import { AuthService } from '@app/auth/auth.service';
import { AppService } from '@app/app.service';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';
import { User } from '@app/models/user.model';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    RouterModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    MatDividerModule,
    MatBadgeModule,
    MatProgressBarModule,
    CommonModule
  ],
  templateUrl: './header.html',
  styleUrls: ['./header.scss'],
})
export class Header implements OnInit {

  user: User | null = null;
  isMobile = false;

  allNavRoutes = [
    { label: 'Dashboard', link: '/dashboard', title: 'Dashboard', icon: 'dashboard' },
  ];

  navRoutes = [...this.allNavRoutes];

  settingsRoutes = [
    // { label: 'Settings', link: '/settings', title: 'Settings', icon: 'settings' },
  ];

  pageTitle: string = 'Load Dealer';

  Math = Math;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private appService: AppService,
    private location: Location,
    private dialog: MatDialog,
  ) {
    this.checkScreenSize();
    this.processRoutes();

    this.appService.headerRefresh$.subscribe(() => {
      this.processRoutes();
    });

    this.router.events.subscribe(() => {
      this.pageTitle = this.getPageTitle(this.route);
    });
  }

  ngOnInit(): void {
    // ...
  }

  getPageTitle(route: ActivatedRoute): string {
    let current = route;

    while (current.firstChild) {
      current = current.firstChild;
    }

    return current.snapshot.data['title'] || '';
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkScreenSize();
  }

  private checkScreenSize(): void {
    this.isMobile = window.innerWidth < 768;
  }

  isActive(route: string): boolean {
    return this.router.url === route;
  }

  logout(): void {
    this.appService.confirm('Are you sure you want to log out?').subscribe((result) => {
      if (result) {
        this.authService.logout();
      }
    });
  }

  processRoutes(): void {
    this.user = this.authService.getUserFromStorage();
    this.navRoutes = this.allNavRoutes.filter(() => true);
  }

  goBack(): void {
    this.router.navigate(['/dashboard']);
  }
}